import { h } from 'preact'
import ButtonControl from '../button-control'
import classNames from 'classnames'

export type Props = {
  fullHeight?: boolean,
  img_src: string,
  header: string,
  text: string | JSX.Element,
  button?: {
    link: string,
    text: string
  },
  children?: JSX.Element
}

const EmptyPage = ({
  fullHeight,
  img_src,
  header,
  text,
  button,
  children
} : Props) => (
  <div className={classNames('control_empty', { 'control_empty--full-height': fullHeight })}>
    <img className='control_empty_image' src={img_src} />
    <h2 className='control_empty_message_header bold'>{header}</h2>
    <div className='control_empty_message_description'>{text}</div>
    {button && <a href={button.link} className='control_empty--btn'>
      <ButtonControl newStyle size='medium' title={button.text} variant='brand' />
    </a>}
    { children && children }
  </div>
)

export default EmptyPage
